import type { PaginatedInfiniteQueryResult } from "@/lib/common/PaginatedInfiniteQueryResult";
import React, { useMemo } from "react";

export type DataViewComponentTypeProps<T, U = undefined> = U extends undefined ? T : T & U;

export type DataViewDataProps<T> = {
	forQuery?: PaginatedInfiniteQueryResult<T>;
} | {
	items?: T[];
};

export type DataViewBaseProps<T, U = undefined> = {
	getKey: (item: T) => React.Key;
	onlyUseGalleryForMobile?: boolean;
	additionalProps?: U;
	scrollRef?: React.RefObject<HTMLElement | null>;
	children?: React.ReactNode;
};

export function useDataItems<T>(props: DataViewDataProps<T>): T[] {
	const items = "items" in props ? props.items : undefined;
	const forQuery = "forQuery" in props ? props.forQuery : undefined;
	return useMemo(() => [
		...items ?? [],
		...forQuery?.data?.pages.flatMap(x => x.results) ?? []
	], [items, forQuery?.data]);
}
